var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 12.096a8 8 0 1 1 8 8H5.06l1.283-1.283a.75.75 0 0 0 0-1.06A7.97 7.97 0 0 1 4 12.096m8-9.5a9.5 9.5 0 0 0-7.227 15.666L2.72 20.315a.75.75 0 0 0 .53 1.28H12a9.5 9.5 0 0 0 0-19m-4.375 8.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m3.125 1.25a1.25 1.25 0 1 1 1.25 1.25c-.69 0-1.25-.559-1.25-1.25m5.625-1.25a1.25 1.25 0 0 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  })));
};
export default SvgChat;